export enum LOCALSTORAGE {
    accessToken = 'ACS_TKN',
    refreshToken = 'RFS_TKN',
    user = 'USR',
    menu = 'MNU',
    documents = 'DOCS',
    tablePagination = 'TBL_PAG',
}
